import { useQuery } from "@tanstack/react-query";
import { apiBase } from "../apis";
import { isAuthenticated } from "@utils/auth";

export const useFetchData = (queryKey, url, config, paginationParams, options = {}) => {
  // Combine authentication check with user-provided enabled option
  const isAuthenticatedAndEnabled = () => {
    // If skipAuth is true, skip authentication check (for public APIs)
    if (options.skipAuth === true) {
      const userEnabled = options.enabled;
      if (userEnabled !== undefined) {
        return typeof userEnabled === 'function' ? userEnabled() : userEnabled;
      }
      return true; // Default to enabled if skipAuth is true
    }
    
    const userEnabled = options.enabled;
    
    // If user provided enabled option, respect it AND check authentication
    if (userEnabled !== undefined) {
      return typeof userEnabled === 'function' 
        ? userEnabled() && isAuthenticated()
        : userEnabled && isAuthenticated();
    }
    
    // If no enabled option provided, just check authentication
    return isAuthenticated();
  };

  // Remove skipAuth from options before passing to useQuery
  const { skipAuth, ...queryOptions } = options;

  return useQuery({
    queryKey,
    queryFn: () =>
      apiBase({
        url,
        params: { ...paginationParams },
        ...config,
        ...(options.skipAuth ? { skipAuth: true } : {}),
      }),
    ...queryOptions,
    enabled: isAuthenticatedAndEnabled(), // Automatically check authentication (unless skipAuth is true)
  });
};
